module.exports = __webpack_public_path__ + "img/207.7dd7ecdf.jpg";